import { Star } from "lucide-react";

const testimonials = [
  {
    name: "Sarah Mitchell",
    role: "Digital Marketing Manager · Fortune 500 SaaS",
    quote:
      "Game-changer for competitor analysis. I finally have a private swipe file that isn't at the mercy of Meta pulling ads offline.",
    image:
      "https://images.unsplash.com/photo-1623366302587-b38b1ddaefd9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHx1c2VyJTIwcG9ydHJhaXQlMjBjb25maWRlbnR8ZW58MHx8fHwxNzg0NDM4NTcwfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "James Chen",
    role: "Growth Lead · DTC Brand",
    quote:
      "Paste, download, done. Zero sign-ups. Zero nag-screens. It just quietly does the one job you need it for — perfectly.",
    image:
      "https://images.unsplash.com/photo-1506863530036-1efeddceb993?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxtYXJrZXRlciUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NTA1ODg4OHww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Aisha Rahman",
    role: "Creative Strategist · Ad Agency",
    quote:
      "The HD quality is exactly what my editors need. I ripped 40 ads from three competitors before my coffee got cold.",
    image:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxtYXJrZXRlciUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NTA1ODg4OHww&ixlib=rb-4.1.0&q=85",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-20 md:py-28 border-t border-zinc-200 dark:border-zinc-800 bg-zinc-100/60 dark:bg-zinc-950/40"
    >
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-14 max-w-3xl">
          <p className="text-xs font-mono uppercase tracking-widest text-yellow-500 mb-3">
            // Word on the street
          </p>
          <h2 className="font-display font-bold text-4xl md:text-6xl text-zinc-900 dark:text-white tracking-tight leading-[0.95]">
            Loved by the teams beating your competitors.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {testimonials.map((t, i) => (
            <figure
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="border border-zinc-200 dark:border-zinc-800 bg-white dark:bg-black p-8 flex flex-col group hover:border-yellow-500 transition-colors"
            >
              <div className="flex items-center gap-1 text-yellow-500">
                {[0, 1, 2, 3, 4].map((s) => (
                  <Star key={s} className="w-4 h-4 fill-yellow-500" />
                ))}
              </div>
              <blockquote className="mt-6 text-zinc-900 dark:text-white text-lg leading-snug font-medium">
                “{t.quote}”
              </blockquote>
              <div className="mt-auto pt-8 flex items-center gap-3">
                <img
                  src={t.image}
                  alt={t.name}
                  className="w-11 h-11 object-cover grayscale group-hover:grayscale-0 transition-all"
                />
                <figcaption>
                  <div className="font-display font-bold text-zinc-900 dark:text-white text-sm">
                    {t.name}
                  </div>
                  <div className="text-xs text-zinc-500 dark:text-zinc-500 mt-0.5">{t.role}</div>
                </figcaption>
              </div>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
